module.exports = __webpack_public_path__ + "img/calculators-icon.b6f904c3.svg";